import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify/lib';
import {Config} from "@/Config";
import HansongModel from "./HansongModel";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdi',
  },

});

Vue.config.productionTip = false;
Vue.prototype.log = window.console.log;
Vue.prototype.model = new HansongModel(new Config());


new Vue({
  render: h => h(App),
  vuetify,
  el: '#app'
});
